import { makeStyles } from '@material-ui/core/styles';

import { UserRole } from 'context/user/userContext/UserContext.types';
import { fontWeight } from 'theme/typography';

export const useStyles = makeStyles(theme => {
  const sideBarWidth = 27.25;
  const mapRoleToColor = {
    [UserRole.Manufacturer]: theme.palette.red.main,
    [UserRole.GoverningBody]: theme.palette.red.main,
    [UserRole.Owner]: theme.palette.primary.main,
    [UserRole.Installer]: theme.palette.yellow.main,
    [UserRole.Verifier]: theme.palette.secondary.main,
  };
  return {
    appBar: {
      backgroundColor: theme.palette.gray.dark,
    },
    toolbar: {
      height: theme.spacing(7.5),
      width: '100%',
      padding: theme.spacing(3, 1.7, 3, 2.1),
      backgroundColor: theme.palette.gray.dark,
      border: 0,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    userName: {
      fontSize: theme.typography.h4.fontSize,
      fontWeight: fontWeight.semiBold,
      fontFamily: theme.typography.secondaryFontFamily,
      color: theme.palette.text.primary,
      marginRight: theme.spacing(1),
    },
    link: {
      cursor: 'pointer',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(sideBarWidth),
      maxWidth: 'unset',
      width: `calc(100% - ${theme.spacing(sideBarWidth)}px)`,
      padding: theme.spacing(2),
      minHeight: `calc(100vh - ${theme.spacing(7.5)}px)`,
    },
    roleAvatar: {
      position: 'relative',
      marginRight: theme.spacing(4),
    },
    avatar: {
      height: theme.spacing(4),
      width: theme.spacing(4),
    },
    roleIcon: ({ role }: { role?: UserRole }) => ({
      position: 'absolute',
      bottom: theme.spacing(-0.25),
      right: theme.spacing(-1),
      backgroundColor: role ? mapRoleToColor[role] : 'transparent',
      borderRadius: '50%',
      width: theme.spacing(2),
      height: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        width: theme.spacing(1.25),
        height: theme.spacing(1.25),
      },
    }),
    sideBar: {
      position: 'fixed',
      left: 0,
      top: 0,
      width: theme.spacing(sideBarWidth),
      height: '100vh',
      backgroundColor: theme.palette.gray.darker,
      zIndex: 1200,
    },
  };
});
